import Head from "next/head";
import { getSimplePageLayout } from "src/components/elements/layout";
import { ConnectIdsBody } from "src/components/features/mypage/connectIds";
import styles from "src/pages/mypage/connectIds/styles.module.scss";

export default function ConnectIds() {
  return (
    <>
      <Head>
        <title>menu -ID連携</title>
        <meta name="description" content="menu -ID連携" />
      </Head>
      <div className={styles.openIdContainer}>
        <ConnectIdsBody />
      </div>
    </>
  );
}

ConnectIds.getLayout = getSimplePageLayout;
